import Navigation from '../Navigation/Navigation';

const Header = ({ pathname }) => {
  return <Navigation pathname={pathname} />;
};

export default Header;
